var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#757575;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,14.9v2c-3.3,0-6,2.7-6,6h-2C3.5,18.5,7.1,14.9,11.5,14.9z M11.5,13.9c-3.3,0-6-2.7-6-6s2.7-6,6-6 s6,2.7,6,6S14.8,13.9,11.5,13.9z M11.5,11.9c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S9.3,11.9,11.5,11.9z M14.1,19.7 c-0.1-0.5-0.1-1.1,0-1.6l-1-0.6l1-1.7l1,0.6c0.4-0.4,0.9-0.7,1.4-0.8v-1.1h2v1.1c0.5,0.2,1,0.4,1.4,0.8l1-0.6l1,1.7l-1,0.6 c0.1,0.5,0.1,1.1,0,1.6l1,0.6l-1,1.7l-1-0.6c-0.4,0.4-0.9,0.7-1.4,0.8v1.1h-2v-1.1c-0.5-0.2-1-0.4-1.4-0.8l-1,0.6l-1-1.7 C13.1,20.3,14.1,19.7,14.1,19.7z M17.5,20.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5S16,18.1,16,18.9S16.7,20.4,17.5,20.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyprofile);
export default __webpack_public_path__ + "static/media/myprofile.4e3156b714bc4c0a403a9f7d10ba3eaf.svg";
export { ForwardRef as ReactComponent };